// get all users
export const getAllProperty = (filters) => ({
    url: "/admin/get_quotations",
    method: "GET",
    params: filters,
  });
  export const getSingleProperty = (id) => ({
    url: `/admin/property/${id}`,
    method: "GET",
  });
  export const deleteProperty = (id) => ({
    url: `/admin/job/${id}`,
    method: "DELETE",
  });
  
  export const updateProperty = ({ id, body }) => ({
    url: `/admin/update-job/${id}`,
    method: "PUT",
    body,
  });
  